import React from "react";
import { Link } from "react-scroll";
import Hero from "../assets/hero.avif";
import Bianca from "../assets/aboutImg.avif";
import quality from "../assets/vectors/quality.svg";
import knowledge from "../assets/vectors/knowledge.svg";
import passion from "../assets/vectors/passion.svg";
import five from "../assets/vectors/five.svg";

const Home = () => {
  return (
    <div id="home" className="flex justify-center w-full mt-12 pb-2">
      <div className="max-w-screen-lg bg-white">
        <div className="relative">
          <img
            className="object-contain w-full h-full"
            src={Hero}
            alt=""
            fetchpriority="high"
            as="image"
            type="image/webp"
          />
          <div className=" absolute top-2/4 sm:top-3/4 left-4 ">
            <div>
              <h1 className="text-[#FF0080] text-lg sm:text-4xl pb-2">
                Reveal your inner beauty
              </h1>
            </div>
            <div>
              <Link
                to="contact"
                hashSpy={true}
                spy={true}
                smooth={true}
                offset={-100}
                duration={800}
              >
                <button className="transition-all ease-linear duration-300 bg-[#Fbe4d4] text-[#2f1847] hover:bg-[#2f1847] hover:text-white text-xl rounded-lg p-1 px-4">
                  Contact now
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Photo by <a href="https://unsplash.com/fr/@freestocks?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">freestocks</a> on <a href="https://unsplash.com/s/photos/makeup-artist?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a>
         */}

        {/* about section */}
        <section className="px-3">
          <div className="">
            <h1 className="text-[#2f1847] text-4xl py-5">About me</h1>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="self-center">
              <img
                className="rounded-lg"
                src={Bianca}
                alt=""
                // loading="lazy"
                // fetchpriority="high"
                // as="image"
                // type="image/webp"
              />
            </div>
            <div className="text-[#2f1847]">
              <h2 className="pt-4 text-2xl ">
                Hi, I am <span className="text-[#FF0080]">Bianca</span>
              </h2>
              <p>
                My passion for makeup started at an early age, much to my
                mother's despair for using her makeup! As soon as I had my own,
                I started experimenting by mixing colors to create astonishing
                results.
              </p>
              <p className="pb-4">
                Soon after I got noticed by my friends and relatives and was
                asked if I ever considered offering my services to people.
                That's when I started doing makeup, initially for close friends
                and family, then for my friends' friends based on
                recomendations.
              </p>
              <Link
                to="gallery"
                hashSpy={true}
                spy={true}
                smooth={true}
                offset={-100}
                duration={800}
              >
                <button className="transition-all ease-linear duration-300 bg-[#2f1847] text-[#ff0080] hover:bg-[#ff0080] hover:text-white text-xl rounded-lg p-1 px-4 ">
                  Check my work
                </button>
              </Link>
            </div>
          </div>
          {/* why choose me */}
          <div className="">
            <h1 className="text-[#2f1847] text-4xl py-5">Why choose me?</h1>
          </div>
          {/* why me section */}
          <div className="">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 text-[#2f1847] p-4">
              {/* sm:grid-flow-col sm:auto-cols-auto */}
              <div className="p-4 w-full justify-self-center shadow-sm shadow-[#2f1847] transition duration-300 ease-linear hover:-translate-y-1 hover:scale-105 hover:shadow-[#2f1847] hover:shadow-md">
                <div className="">
                  <img src={quality} alt="" className="my-0 mx-auto" />
                </div>
                <div className="text-center">
                  <h2 className="text-2xl">Best quality products</h2>
                  <p>Perfect results require the best products</p>
                </div>
              </div>
              <div className="p-4 w-full justify-self-center shadow-sm shadow-[#2f1847] transition duration-300 ease-linear hover:-translate-y-1 hover:scale-105 hover:shadow-[#2f1847] hover:shadow-md">
                <div>
                  <img src={knowledge} alt="" className="my-0 mx-auto" />
                </div>
                <div className="text-center">
                  <h2 className="text-2xl">Knowledgeable</h2>
                  <p>
                    ITEC Diploma in Makeup and Beauty Specialist Certificate
                  </p>
                </div>
              </div>
              <div className="p-4 w-full justify-self-center shadow-sm shadow-[#2f1847] transition duration-300 ease-linear hover:-translate-y-1 hover:scale-105 hover:shadow-[#2f1847] hover:shadow-md">
                <div>
                  <img src={passion} alt="" className="my-0 mx-auto" />
                </div>
                <div className="text-center">
                  <h2 className="text-2xl">Passion for beauty</h2>
                  <p>Highly rated on social networks</p>
                </div>
              </div>
              <div className=" p-4 w-full justify-self-center shadow-sm shadow-[#2f1847] transition duration-300 ease-linear hover:-translate-y-1 hover:scale-105 hover:shadow-[#2f1847] hover:shadow-md">
                <div>
                  <img src={five} alt="" className="my-0 mx-auto" />
                </div>
                <div className="text-center">
                  <h2 className="text-2xl">Years of experience</h2>
                  <p>Proven experience</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;
